<template>
  <div style="padding-left:10px">
    <el-dialog
      class="modal"
      title="代收黑名單"
      :visible.sync="userCBlackModal"
      width="375px"
    >
      <p class="text-danger" style="text-align:center">換行做分隔</p>
      <el-form :model="{}" label-position="top">
        <el-form-item label="請輸入姓名">
          <el-input
            type="textarea"
            v-model="currentData"
            autocomplete="off"
            placeholder="請輸入姓名"
            :rows="5"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="userCBlackModal = false" class="btn">關閉</div>
        <div @click="confirmEditCUserBlack" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="代付黑名單"
      :visible.sync="userPBlackModal"
      width="375px"
    >
      <p class="text-danger" style="text-align:center">換行做分隔</p>
      <el-form :model="{}" label-position="top">
        <el-form-item label="請輸入帳號">
          <el-input
            type="textarea"
            v-model="currentData"
            autocomplete="off"
            placeholder="請輸入帳號"
            :rows="5"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="userPBlackModal = false" class="btn">關閉</div>
        <div @click="confirmEditPUserBlack" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog title="修改密碼" :visible.sync="editPasswordModal" width="375px">
      <el-form :model="form" :rules="rules" ref="editPasswordModal">
        <el-form-item
          label="舊的密碼"
          :label-width="formLabelWidth"
          prop="old_password"
        >
          <el-input v-model="form.old_password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="新的密碼"
          :label-width="formLabelWidth"
          prop="new_password"
        >
          <el-input v-model="form.new_password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="驗證碼"
          :label-width="formLabelWidth"
          prop="new_withdraw_password"
        >
          <el-input v-model="form.oneCode" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editPasswordModal = false" class="btn">取消</div>
        <div @click="confirmEditPassword" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      title="修改提款密碼"
      :visible.sync="editWithdrawPasswordModal"
      width="375px"
    >
      <el-form
        :model="withdrawForm"
        :rules="withdrawRules"
        ref="editWithdrawPasswordModal"
      >
        <el-form-item
          label="舊的密碼"
          :label-width="formLabelWidth"
          prop="old_withdraw_password"
        >
          <el-input
            v-model="withdrawForm.old_withdraw_password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="新的密碼"
          :label-width="formLabelWidth"
          prop="new_withdraw_password"
        >
          <el-input
            v-model="withdrawForm.new_withdraw_password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="驗證碼"
          :label-width="formLabelWidth"
          prop="new_withdraw_password"
        >
          <el-input
            v-model="withdrawForm.oneCode"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editWithdrawPasswordModal = false" class="btn">取消</div>
        <div @click="confirmEditWithdrawPassword" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo menu"
      mode="horizontal"
    >
      <h2 class="navName">
        {{ returnNavName() }}
      </h2>
      <i class="el-icon-s-fold navHandler" @click="showNav"></i>
      <h3 style="margin-left:auto">
        <span
          v-if="
            selfInfo.role_name == 'customer' ||
              selfInfo.role_name == 'customerSub'
          "
          style="margin-right:15px"
          >總餘額:
          {{
            (selfInfo.balance * 1 + selfInfo.unsettlementAmount * 1)
              | decimalPoint
              | thousands
          }}</span
        >
        <span style="margin-right:15px"
          >可用餘額: {{ selfInfo.balance | decimalPoint | thousands }}</span
        >
        <span class="navName">
          {{ selfInfo.name }} - {{ selfInfo.id }} -
          {{ selfInfo.role_name_ch }}
        </span>
      </h3>
      <el-submenu index="1" style="margin-left:unset">
        <template slot="title">選項</template>
        <el-menu-item index="1-1" @click="editPassword">修改密碼</el-menu-item>
        <el-menu-item
          index="1-1"
          v-if="$permission('collections.transactions.blockList')"
          @click="editBlackNmae('c')"
        >
          代收黑名單
        </el-menu-item>
        <el-menu-item
          index="1-1"
          v-if="$permission('payment.transactions.blockList')"
          @click="editBlackNmae"
        >
          代付黑名單
        </el-menu-item>
        <el-menu-item index="1-2" @click="editWithdrawPassword">
          修改提款密碼
        </el-menu-item>
        <el-menu-item index="1-3" @click="signOut">登出</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      note: "",
      alter: "",
      rules: {
        new_password: [
          { required: true, message: "新的密碼", trigger: "blur" },
          { min: 6, message: "最少為6個字元", trigger: "blur" }
        ],
        old_password: [
          { required: true, message: "舊的密碼", trigger: "blur" },
          { min: 6, message: "最少為6個字元", trigger: "blur" }
        ]
      },
      withdrawRules: {
        new_withdraw_password: [
          { required: true, message: "新的密碼", trigger: "blur" },
          { min: 6, message: "最少為6個字元", trigger: "blur" }
        ],
        old_withdraw_password: [
          { required: true, message: "舊的密碼", trigger: "blur" },
          { min: 6, message: "最少為6個字元", trigger: "blur" }
        ]
      },
      activeIndex: "1",
      activeIndex2: "1",
      formLabelWidth: "120px",
      editPasswordModal: false,
      editWithdrawPasswordModal: false,
      form: {},
      withdrawForm: {},
      radio: "1",
      currentData: "",
      userCBlackModal: false,
      userPBlackModal: false
    };
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },
    menuList() {
      return this.$store.state.menuList;
    },
    selfInfo() {
      return this.$store.state.selfInfo;
    }
  },
  methods: {
    confirmEditPUserBlack() {
      let list = this.currentData.split("\n").filter(e => {
        return e != "";
      });
      if (!list.length) {
        list = [""];
      }
      this.$http
        .post(`/back/payment/blockList`, {
          _method: "PUT",
          list
        })
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("修改成功");
            this.currentData = "";
            this.userPBlackModal = false;
            this.$store.dispatch("getSelf");
          }
        });
    },
    confirmEditCUserBlack() {
      let list = this.currentData.split("\n").filter(e => {
        return e != "";
      });
      if (!list.length) {
        list = [""];
      }
      this.$http
        .post(`/back/collection/blockList`, {
          _method: "PUT",
          list
        })
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("修改成功");
            this.currentData = "";
            this.$store.dispatch("getSelf");
            this.userCBlackModal = false;
          }
        });
    },
    editBlackNmae(c) {
      if (c == "c") {
        this.userCBlackModal = true;
        if (this.selfInfo.ds_block_list) {
          this.currentData = this.selfInfo.ds_block_list
            .join()
            .replace(/,/g, "\n");
        } else {
          this.currentData = "";
        }
      } else {
        this.userPBlackModal = true;
        if (this.selfInfo.df_block_list) {
          this.currentData = this.selfInfo.df_block_list
            .join()
            .replace(/,/g, "\n");
        } else {
          this.currentData = "";
        }
      }
    },
    returnNavName() {
      let navName = "";
      Object.keys(this.menuList).forEach(e => {
        Object.keys(this.menuList[e].sub).forEach(sub => {
          if (sub == this.$route.name) {
            navName = `${this.menuList[e][e]} - ${this.menuList[e].sub[sub]}`;
          }
        });
      });
      if (this.$route.name == "notify") {
        return "通知中心";
      }
      return navName;
    },
    showNav() {
      this.$store.dispatch("navHandler", true);
    },
    signOut() {
      this.$http.get(`/back/logout`).then(res => {
        if (res.data.code == 0) {
          this.$message.success("成功登出");
          this.$router.push("/login");
          this.$cookie.delete("token");
        }
      });
    },
    confirmEditPassword() {
      this.$refs["editPasswordModal"].validate(valid => {
        if (valid) {
          this.$http.post(`/back/users/password`, this.form).then(res => {
            if (res.data.code == 0) {
              this.$message.success("修改成功");
              this.form = {};
              this.editPasswordModal = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    editPassword() {
      this.editPasswordModal = true;
    },
    confirmEditWithdrawPassword() {
      this.$refs["editWithdrawPasswordModal"].validate(valid => {
        if (valid) {
          this.$http
            .post(`/back/users/password`, this.withdrawForm)
            .then(res => {
              if (res.data.code == 0) {
                this.$message.success("修改成功");
                this.withdrawForm = {};
                this.editWithdrawPasswordModal = false;
              }
            });
        } else {
          return false;
        }
      });
    },
    editWithdrawPassword() {
      this.editWithdrawPasswordModal = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.el-submenu {
  margin-left: auto;
  margin-right: 10px;
}

.navHandler {
  font-size: 30px;
  display: none;
}
@media (max-width: 992px) {
  .navHandler {
    display: inline-block;
  }
}
.menu {
  display: flex;
  align-items: center;
  width: 100%;
  margin-left: 10px;
}
@media (max-width: 512px) {
  .navName {
    display: none;
  }
}
</style>
